import { z } from 'zod';

export const coordenadorFiltersSchema = z.object({
  escola: z.number().optional(),
});

export type CoordenadorUrlFilters = z.infer<typeof coordenadorFiltersSchema>;
